// Created by hejikun on 2017/10/25 0025.
let state = {
  img_upload_cache: [],
  img_upload_cache_compress: [],
  img_upload_cache_origin: [],
  img_paths: [],
  img_status: 'ready', // 上传状态 ready selected uploading finished
  ecgimg_upload_cache: [], // 以下为临时添加，后续优化
  ecgimg_upload_cache_compress: [],
  ecgimg_upload_cache_origin: [],
  ecgimg_paths: [],
  ecgimg_status: 'ready',
  ctimg_upload_cache: [],
  ctimg_upload_cache_compress: [],
  ctimg_upload_cache_origin: [],
  ctimg_paths: [],
  ctimg_status: 'ready',
  reimg_upload_cache: [],
  reimg_upload_cache_compress: [],
  reimg_upload_cache_origin: [],
  reimg_paths: [],
  reimg_status: 'ready'
}

const actions = {}

const getters = {}

const mutations = {
  set_img_upload_cache(state, arg) {
    state.img_upload_cache = arg
  },
  set_img_upload_cache_compress(state, arg) {
    state.img_upload_cache_compress = arg
  },
  set_img_upload_cache_origin(state, arg) {
    state.img_upload_cache_origin = arg
  },
  set_img_paths(state, arg) {
    state.img_paths = arg
  },
  set_img_status(state, arg) {
    state.img_status = arg
  },
  set_ecgimg_upload_cache(state, arg) {
    // 以下为临时添加，后续优化
    state.ecgimg_upload_cache = arg
  },
  set_ecgimg_upload_cache_compress(state, arg) {
    state.ecgimg_upload_cache_compress = arg
  },
  set_ecgimg_upload_cache_origin(state, arg) {
    state.ecgimg_upload_cache_origin = arg
  },
  set_ecgimg_paths(state, arg) {
    state.ecgimg_paths = arg
  },
  set_ecgimg_status(state, arg) {
    state.ecgimg_status = arg
  },
  set_ctimg_upload_cache(state, arg) {
    // 以下为临时添加，后续优化
    state.ctimg_upload_cache = arg
  },
  set_ctimg_upload_cache_compress(state, arg) {
    state.ctimg_upload_cache_compress = arg
  },
  set_ctimg_upload_cache_origin(state, arg) {
    state.ctimg_upload_cache_origin = arg
  },
  set_ctimg_paths(state, arg) {
    state.ctimg_paths = arg
  },
  set_ctimg_status(state, arg) {
    state.ctimg_status = arg
  },
  set_reimg_upload_cache(state, arg) {
    // 以下为临时添加，后续优化
    state.reimg_upload_cache = arg
  },
  set_reimg_upload_cache_compress(state, arg) {
    state.reimg_upload_cache_compress = arg
  },
  set_reimg_upload_cache_origin(state, arg) {
    state.reimg_upload_cache_origin = arg
  },
  set_reimg_paths(state, arg) {
    state.reimg_paths = arg
  },
  set_reimg_status(state, arg) {
    state.reimg_status = arg
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
